interface ChangeDetectionParams {
  id: string | number;
  field: string;
  newValue: any;
  oldValue: any;
  apiRef: React.MutableRefObject<any>;
}

/**
 * Helper function to handle change detection and grid updates for grid cell components.
 * This function encapsulates the common logic used across all grid cell components
 * to detect changes and emit change detection events.
 */
export const handleGridCellChange = async ({
  id,
  field,
  newValue,
  oldValue,
  apiRef,
}: ChangeDetectionParams): Promise<void> => {
  // Immediately detect if there's a change
  if (newValue !== oldValue) {
    // Get the current row data
    const currentRow = apiRef.current.getRow(id);
    if (currentRow) {
      // Create updated row with the new value
      const updatedRow = { ...currentRow, [field]: newValue };
      
      // Emit change detection event
      if ((window as any).changeDetectionEvents) {
        (window as any).changeDetectionEvents.emit(id, updatedRow);
      }
    }
  }
  
  // Update the grid cell value
  await apiRef.current.setEditCellValue({ id, field, value: newValue });
};

/**
 * Helper function to handle change detection, grid updates, and stop edit mode.
 * This is the most common pattern used across grid cell components.
 */
export const handleGridCellChangeAndStopEdit = async ({
  id,
  field,
  newValue,
  oldValue,
  apiRef,
}: ChangeDetectionParams): Promise<void> => {
  await handleGridCellChange({ id, field, newValue, oldValue, apiRef });
  apiRef.current.stopCellEditMode({ id, field });
}; 